import {Directive, Renderer, ElementRef, Input} from '@angular/core';

@Directive({
  selector: '[activeStatus]'
})
export class ActiveStatusDirective {

  @Input('activeStatus') activeStatus;

  constructor(private el: ElementRef,
              private renderer: Renderer,) {
    setTimeout(() => {
      this.check();
    }, 0);
  }


  check() {
    var addClass = "";
    var status = "";
    this.activeStatus = +this.activeStatus;
    if(this.activeStatus == 0){
      addClass = "badge-danger";
      status= " Not Active ";
    }
    else if(this.activeStatus == 1 || this.activeStatus == -1){
      addClass = "badge-success";
      status= " Active ";
    }
    var d1 = this.el.nativeElement;
    d1.insertAdjacentHTML('beforeend', '<span class="text-white ">' + status + '</span>');
    this.renderer.setElementClass(this.el.nativeElement,"badge",true);
    this.renderer.setElementClass(this.el.nativeElement,"badge-pill",true);
    this.renderer.setElementClass(this.el.nativeElement,addClass,true);

  }
}

export const ActiveStatusDirective_DIRECTIVES = [
  ActiveStatusDirective
];



// WEBPACK FOOTER //
// /app/src/app/directives/active-status/active-status.directive.ts